import loadingIndicator from "../new-boost/js/loading_indicator";
import debounce_helper from '../new-boost/js/debounce_helper';
import GenericBoostModal from "./generic-boost-modal";
import checkAndSetDebugMode from './checkAndSetDebugMode';

const CHANGE_AGENT_WIDGET = 'change-agent-widget';
const CHANGE_AGENT_MODAL = 'change-agent-modal';

function log($message) {
    if (window.debug) console.log($message);
}

function getCustomerShortCode() {
    let mainForm = jQuery('form[name=main]')[0];
    return jQuery(mainForm).find('input[name=customer_short_code]')[0].value;
}

// here we initialize the handler for searching for potential campaign agents
function initCampaignAgentSearch() {
    const customerShortCode = getCustomerShortCode();
    const url = '/dashboard/boost_cart/get_agents_search/' + customerShortCode;
    let numAjaxCallsPending = 0;
    let $changeAgentElement = jQuery(`.${CHANGE_AGENT_WIDGET}`);

    let inputHandler = debounce_helper(250, (e) => {
        log('rebrand_campaign_agent_search: input has changed');
        let input = e.target;
        let contextQuery = input.value.trim();

        if (!contextQuery) {
            clearAgentResultsMenu();
            return;
        }

        loadingIndicator.show();
        numAjaxCallsPending++;

        log('rebrand_campaign_agent_search: making ajax request');
        jQuery.getJSON(url, {context_query: contextQuery})
            .done((data) => {
                log(data);
                addAgentResultsToMenu(data);
            })
            .fail(() => {
                log('rebrand_campaign_agent_search: ajax call error');
            })
            .always(() => {
                numAjaxCallsPending--;
                if (numAjaxCallsPending < 1) { loadingIndicator.hide(); }
            });
    })

    const searchClass = `.${CHANGE_AGENT_WIDGET}__search--js`;
    $changeAgentElement.off().on('input', searchClass, inputHandler);
    $changeAgentElement.on('focusin', searchClass, inputHandler);
    $changeAgentElement.on('focusout', searchClass, () => {
        $(`.${CHANGE_AGENT_WIDGET}__search-results`).fadeOut();
    });
}

function clearAgentResultsMenu() {
    jQuery(`.${CHANGE_AGENT_WIDGET}__search-results`).hide();
    jQuery(`.${CHANGE_AGENT_WIDGET}__search-results li`).remove();
}

function addAgentResultsToMenu(agentObjects) {
    log('addAgentResultsToMenu');

    clearAgentResultsMenu();

    if (agentObjects && agentObjects.length > 0) {
        $(`.${CHANGE_AGENT_WIDGET}__search-results`).show();
        agentObjects.forEach((value, index, array) => {
            const name = value.first_name + ' ' + value.last_name;
            let li = `<li data-agent-id="${value.id}" data-agent-name="${name}" data-agent-photo="${value.photo_url}">
                        ${name}
                      </li>`;
            $(`.${CHANGE_AGENT_WIDGET}__search-results`).append(li);
        })
    }
}

function initAgentSelectionHandling() {
    jQuery(`.${CHANGE_AGENT_WIDGET}__search-results`).on('click', `li`, (e) => {

        let agentSelectedElement = $(e.target);
        // get info about agent off the element
        const agentId = agentSelectedElement.attr('data-agent-id');
        const agentName = agentSelectedElement.attr('data-agent-name');
        const agentPhotoUrl = agentSelectedElement.attr('data-agent-photo');

        // put the agent info into the form for submission
        let submitElement = jQuery(`.${CHANGE_AGENT_MODAL}__submit`);
        let submitUrl = new URL(submitElement.attr('href'));
        submitUrl.searchParams.set('agent_id', agentId)
        submitUrl.search = submitUrl.searchParams.toString();
        submitElement.attr('href', submitUrl.toString());

        jQuery(`.${CHANGE_AGENT_MODAL}__selected-agent-photo`).attr('src', agentPhotoUrl);
        jQuery(`.${CHANGE_AGENT_MODAL}__selected-agent-name`).text(agentName);
        clearAgentResultsMenu();
    });
}

function rebrandCampaignAgentSearchInit() {
    // we only want to load on the boost detail page, not other pages
    let widget = jQuery(`.${CHANGE_AGENT_WIDGET}`);
    if (!widget || widget.length === 0) {
        return;
    }

    let ChangeAgentModal = new GenericBoostModal(
        `.${CHANGE_AGENT_WIDGET}__search-results`,
        `li`,
        '.change-agent-modal--js',
        '.change-agent-modal__close--js',
        'change-agent-modal--active',
        'change-agent-modal__bg'
    );

    initCampaignAgentSearch();
    initAgentSelectionHandling();
}

$(document).ready(() => {
    checkAndSetDebugMode();
    rebrandCampaignAgentSearchInit();
});